module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/36bc26581a9e802c2eec7be5f9de15b2.png";